import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider } from '@tribeplatform/react-ui-kit/Divider';
import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown';
import { useCommandBar } from '../CommandBar';
import { T } from '../i18n';
import { ActionItem } from './ActionItem';
import { usePostActionItems } from './hooks/usePostActionItems';
const NUMBER_OF_SHORTCUTS_TO_SHOW = 3;
export const PostActionItems = ({ post, context, className, showShortcuts, }) => {
    const { open } = useCommandBar();
    const { actions, shortcuts, children } = usePostActionItems({
        post,
        context,
        fetchShortcuts: showShortcuts,
    });
    return (_jsxs(_Fragment, { children: [_jsxs(Dropdown.Items, { className: className, children: [actions.map((action, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    _jsx(ActionItem, { ...action, isShortcut: false }, index))), (shortcuts === null || shortcuts === void 0 ? void 0 : shortcuts.length) > 0 && _jsx(Divider, { padding: "sm" }, void 0), shortcuts === null || shortcuts === void 0 ? void 0 : shortcuts.slice(0, NUMBER_OF_SHORTCUTS_TO_SHOW).map((shortcut, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    _jsx(ActionItem, { ...shortcut, isShortcut: true }, index))), (shortcuts === null || shortcuts === void 0 ? void 0 : shortcuts.length) > NUMBER_OF_SHORTCUTS_TO_SHOW && (_jsx(_Fragment, { children: _jsx(Dropdown.Item, { onClick: () => open({
                                context: { entity: post, entityType: 'post' },
                                excludeActions: [
                                    'posts',
                                    'navigations',
                                    'adminSettings',
                                    'search',
                                ],
                            }), children: _jsx(T, { defaultMessage: "Load more...", id: "PostActionItems.LoadMoreDotDotDot" }, void 0) }, "load-more") }, void 0))] }, void 0), children] }, void 0));
};
//# sourceMappingURL=PostActionItems.js.map